import axios from "axios";
import { SET_ERROR, ADD_EXPIRATION_DATE } from "../../types"

export const getWarrantyExpiration = async (itemId) => {
    let response = await axios.post(`api/items/get-warranty-expiration/${itemId}`);
    return response.data.data || [];
}

export const AddWarrantyExpiration = (payload) => {
    return async (dispatch) => {
        await axios.post(`api/items/add-warranty-expiration`, payload).then(response => {
            dispatch({
                type: ADD_EXPIRATION_DATE,
                payload: response.data.data
            });
        }).catch(e => {
            dispatch({
                type: SET_ERROR,
                payload: {
                    e, error: true
                }
            })
        })
    }
};
